import { render } from "./TvmFlowEndItems.vue?vue&type=template&id=f5698fec"
import script from "./TvmFlowEndItems.vue?vue&type=script&lang=js"
export * from "./TvmFlowEndItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ChatWidget/TvmFlowEndItems/TvmFlowEndItems.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f5698fec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f5698fec', __exports__)) {
    api.reload('f5698fec', __exports__)
  }
  
  module.hot.accept("./TvmFlowEndItems.vue?vue&type=template&id=f5698fec", () => {
    api.rerender('f5698fec', render)
  })

}


export default __exports__